var module = angular.module('octopusApp.library');

module.controller('PackageUploadController', function($scope, $location, busy, octopusRepository, octoUploader) {
  var octoUpload = octoUploader.create($scope);

  $scope.isLoading = busy.create();
  $scope.isUploading = busy.create();
  $scope.octoUpload = octoUpload;
  $scope.uploadOptions = {
    replace: false
  };
  $scope.beginUpload = beginUpload;

  $scope.cancel = function() {
    octoUpload.cancel();

    var form = $("#packageUpload")[0];
    if (form) {
      form.reset();
    }
  };

  function beginUpload() {
    var url = octopusRepository.Packages.getUploadUrl({ replace: $scope.uploadOptions.replace });
    $scope.isUploading.promise(octoUpload.begin(url).then(function(uploaded){
      $location.path('/library/packages/' + uploaded.Id);
    }));
  }
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/library/packages/controllers/package_upload_controller.js
// module id = 5655056073288354
// module chunks = 1